import { isIosSafari } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { onCLS, onFCP, onLCP, onTTFB } from 'web-vitals/attribution';
import { constructWebVitalMetric, getNumbersWithInterval } from '../helpers/Utils/utils';

const intervals = {
    CLS: getNumbersWithInterval(0.02, 0.3),
    FCP: getNumbersWithInterval(0.25, 4),
    LCP: getNumbersWithInterval(0.25, 8),
    TTFB: getNumbersWithInterval(0.1, 1.9),
};

const reportWebVitals = (onPerfEntry, enableWebvitalsReportAllChanges) => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        onFCP(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
        onTTFB(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
        onLCP(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
        onCLS(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
        // INp will be phase2
        // onINP(onPerfEntry, { reportAllChanges: enableWebvitalsReportAllChanges });
    }
};
/* istanbul ignore next */
const getPageInfo = (digitalData, reqAttr = []) => {
    let pageInfo = {};
    // If the required attributes in config is empty, just return with default page info
    // default attributes are => analyticsPageName, pageType, jcpSessionId, amId and deviceType
    if (reqAttr.length === 0) {
        pageInfo = {
            analyticsPageName: digitalData?.page?.pageInfo?.analyticsPageName,
            pageType: digitalData?.page?.pageInfo?.pageType,
            jcpSessionId: digitalData?.user?.profile?.profileInfo?.jcpSessionID,
            amId: digitalData?.user?.profile?.profileInfo?.amID,
            deviceType: digitalData?.page?.pageInfo?.deviceType,
        };
    } else {
        let allAttrsFound = false; // Flag to track whether all required attributes are found
        const traverse = (data) => {
            if (data && typeof data === 'object') {
                Object.keys(data).forEach((key) => {
                    if (allAttrsFound) return; // Exit traversal if all required attributes are found
                    const value = data[key];
                    if (typeof value === 'object') {
                        traverse(value);
                    } else if (reqAttr.includes(key)) {
                        pageInfo[key] = value;
                        if (Object.keys(pageInfo).length === reqAttr.length) {
                            allAttrsFound = true; // Set flag to true if all required attributes are found
                        }
                    }
                });
            }
        };
        traverse(digitalData);
    }
    return pageInfo;
};

export const logwebvitals = (store, digitalData = {}) => {
    const stateObj = store.getState();
    const disableTrackWebVitals = stateObj?.context?.featureFlags?.disableTrackWebVitals;
    const enableWebvitalsReportAllChanges =
        stateObj?.context?.featureFlags?.enableWebvitalsReportAllChanges || true;
    const isWebvitalsTriggered = stateObj?.webvitals?.isWebvitalsTriggered;
    const {
        webvitalEndpoint = 'https://api.jcpclick.com/p/collector',
        webVitalsPageInfoAttributes,
    } = stateObj?.context?.preferences;

    /* istanbul ignore next */
    if (!disableTrackWebVitals && !isWebvitalsTriggered) {
        store.dispatch({
            type: 'TRIGGER_WEBVITALS',
        });
        const data = { webvitals: {} };
        const metricData = {};

        const handleVisibilityStateChange = () => {
            console.log('visibilitychange changed to', document.visibilityState);
            if (document.visibilityState === 'hidden') {
                data.eventName = 'visibilitystate hidden event';
                console.log('visibilitychange hidden triggered');
                doAnalytics();
            }
        };

        const handlepagehide = () => {
            console.log('handlepagehide triggered');
            data.eventName = 'handlepagehide hidden event';
            doAnalytics();
        };
        /* istanbul ignore next */
        const doAnalytics = () => {
            const pageInfo = getPageInfo(digitalData, webVitalsPageInfoAttributes);
            pageInfo.pageLoad =
                window?.performance?.timing.loadEventEnd -
                window?.performance?.timing?.navigationStart;
            data.webvitals = Object.entries(metricData).map((eachObj) => ({
                [eachObj[0]]: eachObj[1],
            }));
            data.webvitals.push({ pageInfo });

            navigator.sendBeacon(webvitalEndpoint, JSON.stringify({ ...data }));
            document.removeEventListener('visibilitychange', handleVisibilityStateChange);
            if (isIosSafari()) {
                window.removeEventListener('pagehide', handlepagehide);
            }
        };

        const attachListeners = () => {
            document.addEventListener('visibilitychange', handleVisibilityStateChange);
            if (isIosSafari()) {
                window.addEventListener('pagehide', handlepagehide);
            }
        };

        reportWebVitals((eachMetric) => {
            const metric = constructWebVitalMetric(eachMetric, intervals);
            metricData[metric?.name] = metric;
        }, enableWebvitalsReportAllChanges);

        attachListeners();
    }
};

export default logwebvitals;
